<div class="main-section cx-one-ui">
    <div class="form-container cx-one-ui">
        <form id="reporting-set-joined-feed" [formGroup]="reportingSetJoinedFeed">

            <div class="joined-feed-name-group">
                <div class="joined-feed-group">
                    <label for="joined-name-field" id="reporting-set-name-label" cvLocalizedText
                        langSection="ETL_Reporting_Set" langKey="Joined_Feed_Name">Joined Feed Name
                    </label> <span class="field-required"> * </span>
                    <cxone-text-input type="text" class="joined-name-field" id="joined-name-field"
                        formControlName="joinedFeedName" [placeholder]="feedNamePlaceholderText"></cxone-text-input>
                </div>

                <div class="checkbox">
                    <cxone-checkbox type="checkbox" formControlName="checkbox" [labelText]="checkboxLabel"
                        id="required_Join"></cxone-checkbox>
                </div>
            </div>

            <div class="feed-group">
                <div class="joined-feed-group">
                    <label for="feed-1" id="feed-1-label" cvLocalizedText langSection="ETL_Reporting_Set"
                        langKey="Feed_1">Feed 1 </label><span class="field-required"> * </span>
                    <cxone-singleselect-dropdown id="feed-1" [placeholder]="dropdownPlaceholderText"
                        [readonly]="editjoinedFeed" [options]="feed1Options"
                        (selectionChanged)="feed1SelectionChanged()" formControlName="feed1" [showFooter]="false"
                        [sortOrder]="'false'">
                    </cxone-singleselect-dropdown>
                </div>

                <div class="joined-feed-group feed-2">
                    <label for="feed-1" id="feed-1-label" cvLocalizedText langSection="ETL_Reporting_Set"
                        langKey="Feed_2">Feed 2 </label><span class="field-required"> * </span>
                    <cxone-singleselect-dropdown id="feed-2" [placeholder]="dropdownPlaceholderText"
                        [readonly]="editjoinedFeed" (selectionChanged)="feed2SelectionChanged()"
                        [options]="feed2Options" formControlName="feed2" [showFooter]="false" [sortOrder]="'false'"
                        [label]="'dropdownOptions'" [primaryKey]="'dropdownOptions'">
                    </cxone-singleselect-dropdown>
                </div>
            </div>

            <hr class="horizontal-line">

            <label class="joined-fields-header" id="joined-fields-" cvLocalizedText langSection="ETL_Reporting_Set"
                langKey="Joined_Fields">Joined Fields </label>

            <ng-container formArrayName="joinedFields">
                <div class="field-group"
                    *ngFor="let control of reportingSetJoinedFeed.controls.joinedFields['controls']; index as i; last as isLast"
                    [formGroupName]="i">

                    <div class="joined-feed-group">
                        <ng-container *ngIf="i==0">
                            <label for="Field1" id="feed-1-label" cvLocalizedText langSection="ETL_Reporting_Set"
                                langKey="Field_1">Field 1 </label><span class="field-required"> * </span>
                        </ng-container>

                        <cxone-singleselect-dropdown id="Field1" [options]="field1Options" [label]="'dropdownOptions'"
                            [primaryKey]="'dropdownOptions'" [placeholder]="dropdownPlaceholderText"  [sortOrder]="'false'"
                            formControlName="field1">
                        </cxone-singleselect-dropdown>
                    </div>

                    <div class="join-1">
                        <svg class="icon-16" [ngClass]="{'disabled-icon': !reportingSetJoinedFeed.controls.joinedFields['controls'][i].valid}">
                            <use href="../App_Themes/CXone/icons/join.svg#join"></use>
                        </svg>
                    </div>

                    <div class="joined-feed-group">
                        <ng-container *ngIf="i==0">
                            <label for="Field2" id="feed-1-label" cvLocalizedText langSection="ETL_Reporting_Set"
                                langKey="Field_2">Field 2 </label><span class="field-required"> * </span>
                        </ng-container>

                        <cxone-singleselect-dropdown id="Field2" [options]="field2Options" [showFooter]="false"
                            [placeholder]="dropdownPlaceholderText" [label]="'dropdownOptions'"
                            [primaryKey]="'dropdownOptions'" [sortOrder]="'false'" formControlName="field2">
                        </cxone-singleselect-dropdown>
                    </div>

                    <div class="actions">
                        <button [disabled]="reportingSetJoinedFeed.controls.joinedFields['controls'].length <= 1"
                            class="icon pl-1" id="trash-icon" (click)="removeJoinedFields(i)">
                            <svg class="icon-16" id="trash-icon-svg">
                                <use href="../App_Themes/CXone/icons/delete.svg#delete"></use>
                            </svg>
                        </button>
                        <button class="icon" id="add-icon" [disabled]="!reportingSetJoinedFeed.controls.joinedFields['controls'][i].valid" (click)="addJoinedFields()" *ngIf="isLast">
                            <svg class="icon-16">
                                <use href="../App_Themes/CXone/icons/add.svg#add"></use>
                            </svg>
                        </button>
                    </div>
                </div>
            </ng-container>

            <label class="joined-fields-header" id="joined-fields-" cvLocalizedText langSection="ETL_Reporting_Set"
                langKey="Join_Criteria">Join Criteria</label>

            <div class="feed-group">
                <div class="joined-feed-group">
                    <label for="Field1" id="field-1-label" cvLocalizedText langSection="ETL_Reporting_Set"
                        langKey="Field_1">Field 1
                    </label>

                    <cxone-singleselect-dropdown id="Field1" [options]="field1Options" [label]="'dropdownOptions'"
                        [placeholder]="dropdownPlaceholderText" [primaryKey]="'Name'" formControlName="filterField1"
                        (ngModelChange)="SetFilterField1DataType($event)" [sortOrder]="'false'">
                    </cxone-singleselect-dropdown>
                </div>

                <div class="joined-feed-group feed-2">
                    <label for="Field2" id="field-2-label" cvLocalizedText langSection="ETL_Reporting_Set"
                        langKey="Field_2">Field 2 </label>

                    <cxone-singleselect-dropdown id="Field2" [options]="field2Options" [showFooter]="false"
                        [label]="'dropdownOptions'" [primaryKey]="'Name'"  [sortOrder]="'false'"
                        [placeholder]="dropdownPlaceholderText" formControlName="filterField2"
                        (ngModelChange)="SetFilterField2DataType($event)">
                    </cxone-singleselect-dropdown>
                </div>
            </div>

            <div class="feed-group mt-4">
                <div class="joined-feed-group cx-one-ui">
                    <label for="field-1-comparison-input" id="filter-field-1-comparison-label" cvLocalizedText
                        langSection="ETL_Reporting_Set" langKey="Comparison_Value">Comparison Value
                    </label> <span class="field-required"> * </span>

                    <cxone-text-input
                        *ngIf="FilterField1DataType === undefined || FilterField1DataType === null || FilterField1DataType === -1 || FilterField1DataType === 0"
                        type="text" class="report-text-input" id="field-1-comparison-text-input"
                        [placeholder]="comparisonValuePlaceholder"
                        formControlName="filterField1Comparison"></cxone-text-input>

                    <cxone-numeric-selector *ngIf="FilterField1DataType === 1" class="report-text-input"
                        id="field-1-comparison-numeric-input-1" [(ngModel)]="Field1NumericValue" [min]="0"
                        formControlName="filterField1Comparison"></cxone-numeric-selector>

                    <cxone-numeric-selector *ngIf="FilterField1DataType === 2" class="report-text-input"
                        id="field-1-comparison-numeric-input-2" [(ngModel)]="Field1NumericValue"
                        formControlName="filterField1Comparison"></cxone-numeric-selector>

                    <cxone-combined-datetime-picker *ngIf="FilterField1DataType === 3" [(ngModel)]="Field1DateValue"
                        mode="page" id="field-1-comparison-date-input" class="report-text-input"
                        [shortDateTimeFormat]="'MMM D, YYYY h:mm A'" [removeShadows]="true"
                        [ngModelOptions]="{standalone: true}">
                    </cxone-combined-datetime-picker>

                    <cxone-singleselect-dropdown *ngIf="FilterField1DataType === 4" [(ngModel)]="Field1BooleanValue"
                        id="field-1-comparison-dropdown-input" [placeholder]="dropdownPlaceholderText"
                        [options]="booleanDropDownOptions" formControlName="filterField1Comparison"
                        [showFooter]="false"  [sortOrder]="'false'">
                    </cxone-singleselect-dropdown>

                    <button [disabled]="disableAddButton(1)" cvLocalizedText langSection="ETL_Reporting_Set"
                        langKey="Add" class="cxone-btn btn-small btn-primary mt-4"
                        (click)="compareValue('1')">add</button>

                    <ng-container *ngFor="let item of filterComparedSText.field1; index as i;">
                        <div class="compared-text">
                            <div>{{item}}</div>
                            <div class="close-icon" (click)="removeComparedText('1', i)">
                                <span>
                                    <svg>
                                        <use href="../App_Themes/CXone/icons/close.svg#close" id="delete-svg-icon">
                                        </use>
                                    </svg>
                                </span>
                            </div>
                        </div>
                    </ng-container>
                </div>

                <div class="joined-feed-group feed-2">
                    <label for="field-2-comparison-input" id="filter-field-2-comparison-label" cvLocalizedText
                        langSection="ETL_Reporting_Set" langKey="Comparison_Value">Comparison Value
                    </label> <span class="field-required"> * </span>

                    <cxone-text-input type="text"
                        *ngIf="!FilterField2DataType || FilterField2DataType === -1 || FilterField2DataType === 0"
                        class="report-text-input" id="field-2-comparison-input"
                        [placeholder]="comparisonValuePlaceholder"
                        formControlName="filterField2Comparison"></cxone-text-input>

                    <cxone-numeric-selector *ngIf="FilterField2DataType === 1" class="report-text-input"
                        id="field-2-comparison-numeric-input-1" [(ngModel)]="Field2NumericValue" [min]="0"
                        formControlName="filterField2Comparison"></cxone-numeric-selector>

                    <cxone-numeric-selector *ngIf="FilterField2DataType === 2" class="report-text-input"
                        id="field-2-comparison-numeric-input-2" [(ngModel)]="Field2NumericValue"
                        formControlName="filterField2Comparison"></cxone-numeric-selector>

                    <cxone-combined-datetime-picker *ngIf="FilterField2DataType === 3" [(ngModel)]="Field2DateValue"
                        mode="page" id="field-2-comparison-date-input" class="report-text-input"
                        [shortDateTimeFormat]="'MMM D, YYYY h:mm A'" [removeShadows]="true"
                        [ngModelOptions]="{standalone: true}">
                    </cxone-combined-datetime-picker>

                    <cxone-singleselect-dropdown *ngIf="FilterField2DataType === 4" [(ngModel)]="Field2BooleanValue"
                        id="field-2-comparison-dropdown-input" [placeholder]="dropdownPlaceholderText"
                        [options]="booleanDropDownOptions" formControlName="filterField2Comparison"
                        [showFooter]="false"  [sortOrder]="'false'" [search]="false">
                    </cxone-singleselect-dropdown>

                    <button [disabled]="disableAddButton(2)" cvLocalizedText langSection="ETL_Reporting_Set"
                        langKey="Add" class="cxone-btn btn-small btn-primary mt-4"
                        (click)="compareValue('2')">add</button>

                    <ng-container *ngFor="let item of filterComparedSText.field2; index as i;">
                        <div class="compared-text">
                            <div>{{item}}</div>
                            <div class="close-icon" (click)="removeComparedText('2', i)">
                                <span>
                                    <svg>
                                        <use href="../App_Themes/CXone/icons/close.svg#close" id="delete-svg-icon">
                                        </use>
                                    </svg>
                                </span>
                            </div>
                        </div>
                    </ng-container>
                </div>
            </div>
        </form>
    </div>
</div>
